import { CategorizedMessages } from '../../screens/ImportantMessagesScreen'
import { Mtds } from 'prove-common'

export type ImportantMessagesToggleValue = 'active' | 'expired' | 'all'

type ImportantMessagesScreenToggleGroupProps = {
  toggleValue: ImportantMessagesToggleValue
  setToggleValue: (value: ImportantMessagesToggleValue) => void
  categorizedMessages: CategorizedMessages
}

export const ImportantMessagesScreenToggleGroup = ({
  toggleValue,
  setToggleValue,
  categorizedMessages
}: ImportantMessagesScreenToggleGroupProps) => {
  const items = [
    ['active', `Aktive (${categorizedMessages.activeMessages.length})`],
    ['expired', `Utgått (${categorizedMessages.expiredMessages.length})`],
    ['all', `Alle (${categorizedMessages.allMessages.length})`]
  ] as const

  return (
    <Mtds.Togglegroup
      {...({ focusgroup: 'radiogroup' } as Record<string, string>)}
      aria-label='Viktige meldinger'
    >
      {items.map(([value, label]) => (
        <Mtds.Togglegroup.Item
          name='important-messages-toggle'
          key={value}
          value={value}
          checked={toggleValue === value}
          onChange={() => setToggleValue(value)}
        >
          {label}
        </Mtds.Togglegroup.Item>
      ))}
    </Mtds.Togglegroup>
  )
}
